export default {"src":"/_next/static/media/3D-Button.5d5333f9.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};